import React, { useEffect } from 'react'
import './app.css'
import { Routes, Route, useLocation } from 'react-router-dom'
import Footer from './Components/Footer/Footer'
import Home from './Components/Home/Home'
import Main from './Components/Main/Main'
import Materials from './Components/Materials/Materials'
import Navbar from './Components/Navbar/Navbar'
import Activities from './Components/Activities/Activities'
import ArticlePage from './Components/Activities/ArticlePage'
import GalleryPage from './Components/Materials/GalleryPage'
import Partner from "./Components/Partner/Partner";
import LoadingScreen from "./LoadingScreen";
import CoreTeam from "./Components/Core Team/CoreTeam";

// Landing page (all sections)
function Landing() {
    const location = useLocation();

    // When navigated back from another page with a scroll target, honor it
    useEffect(() => {
        const target = location.state?.scrollTo;
        if (target) {
            const timer = setTimeout(() => {
                const element = document.getElementById(target);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 250);
            // Clear the state so a refresh doesn't re-scroll
            window.history.replaceState({}, '');
            return () => clearTimeout(timer);
        }
    }, [location]);

    return (
        <>
            <div id="home">
                <Home/>
            </div>
            <div id="about">
                <Main/>
                <CoreTeam/>
            </div>
            <div id="activities">
                <Activities/>
            </div>
            <div id="gallery">
                <Materials/>
            </div>
            <div id="partners">
                <Partner/>
            </div>
            <div id="contact">
                <Footer/>
            </div>
        </>
    );
}

// This is the main App
function App() {
    return (
        <LoadingScreen>
            <div className="App">
                <Navbar/>
                <Routes>
                    <Route path="/" element={<Landing/>}/>
                    <Route path="/actualites/:id" element={<ArticlePage/>}/>
                    <Route path="/galerie" element={<GalleryPage/>}/>
                </Routes>
            </div>
        </LoadingScreen>
    );
}

export default App
